import {
    RESET_STATE,
    FETCH_RATES_START,
    FETCH_RATES_SUCCESS,
    FETCH_RATES_ERROR,
    FETCH_RATES_CANCEL,
    UPDATE_RATE_START,
    UPDATE_RATE_SUCCESS,
    UPDATE_RATE_ERROR,
    RESET_UPDATE_STATE,
    REMOVE_UPDATE_ERROR,
} from './constants';
import * as sessionConstants from 'containers/App/session/constants';

export const apiInitialState = {
    fetching: false,
    error: null,
    data: null,
    filters: {},
    fetched: false,
};

export const initialState = {
    rates: apiInitialState,
    update: apiInitialState,
};

const reducer = (state = initialState, action) => {
    const { type, params, data, error } = action;

    switch (type) {
        case sessionConstants.SELECT_PROPERTY:
        case RESET_STATE:
        case FETCH_RATES_CANCEL:
            return initialState;
        case FETCH_RATES_START:
            return {
                ...state,
                rates: {
                    ...initialState.rates,
                    fetching: true,
                    filters: params,
                },
            };
        case FETCH_RATES_SUCCESS:
            return {
                ...state,
                rates: {
                    ...state.rates,
                    fetching: false,
                    data,
                    fetched: true,
                },
            };
        case FETCH_RATES_ERROR: {
            return {
                ...state,
                rates: {
                    ...state.rates,
                    fetching: false,
                    fetched: true,
                    error,
                },
            };
        }

        case RESET_UPDATE_STATE:
            return {
                ...state,
                update: initialState.update,
            };
        case UPDATE_RATE_START:
            return {
                ...state,
                update: {
                    ...initialState.update,
                    fetching: true,
                    filters: params,
                },
            };
        case UPDATE_RATE_SUCCESS: {
            const updatedRates = state.update.filters.type === 'update' ? data : [data];
            const newRates =
                state.rates.data &&
                state.rates.data.map((originalRow) => {
                    const updatedRate = updatedRates.find((updateRow) => updateRow.stayDate === originalRow.stayDate);
                    return updatedRate === undefined ? originalRow : updatedRate;
                });
            return {
                ...state,
                update: {
                    ...state.update,
                    fetching: false,
                    data,
                    fetched: true,
                },
                rates: {
                    ...state.rates,
                    data: newRates,
                },
            };
        }
        case UPDATE_RATE_ERROR: {
            return {
                ...state,
                update: {
                    ...state.update,
                    fetching: false,
                    error,
                    fetched: true,
                },
            };
        }
        case REMOVE_UPDATE_ERROR: {
            return {
                ...state,
                update: {
                    ...state.update,
                    error: null,
                },
            };
        }

        default:
            return state;
    }
};

export default reducer;
